<template>
  <div>车辆救援</div>
</template>

<script>
export default {
name:'',
data(){
return {};
}
};

</script>
<style  lang="scss" scoped>
</style>